import React, { createContext, useState, useRef } from 'react';
import emailjs from '@emailjs/browser';

export const QueryModalContext = createContext();

export const QueryModalProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <QueryModalContext.Provider value={{ openModal, closeModal, isModalOpen }}>
      {children}
      <QueryModal />
    </QueryModalContext.Provider>
  );
};

const QueryModal = () => {
  const { isModalOpen, closeModal } = React.useContext(QueryModalContext);
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState('');

  if (!isModalOpen) return null;

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_mnf6trq', // replace with your EmailJS Service ID
        'template_uy1qmij', // replace with your EmailJS Template ID
        form.current,
        '7XcVIAO0rCQHcNoz6' // replace with your EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          setSuccessMessage('Message sent successfully!');
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          setSuccessMessage('Failed to send message. Please try again.');
        }
      );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
      <div className="relative w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-2xl xl:max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="contact-form-area-wrapper bg-white p-4 sm:p-6 lg:p-8 rounded-xl shadow-lg">
          <button
            onClick={closeModal}
            className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-700 z-10"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 sm:h-6 sm:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <h4 className="text-lg sm:text-xl md:text-2xl font-bold mb-4 sm:mb-6 pr-8">Let's Get in Touch / Share Requirements</h4>

          <form ref={form} onSubmit={sendEmail} className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="single">
                <input
                  type="text"
                  name="user_name"
                  placeholder="Your Name"
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="single">
                <input
                  type="tel"
                  name="user_phone"
                  placeholder="Phone Number"
                  className="w-full px-3 py-2.5 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>
            <div className="single">
              <input
                type="email"
                name="user_email"
                placeholder="Email Address"
                className="w-full px-3 py-2.5 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div className="single">
              <textarea
                name="message"
                placeholder="Type Your Message"
                rows="4"
                className="w-full px-3 py-2.5 sm:px-4 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                required
              ></textarea>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <button
                type="submit"
                className="w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 bg-[#00a3A1] hover:bg-[#0a8f8d] text-white font-semibold text-sm sm:text-base rounded-lg transition duration-300"
              >
                Send Message
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 bg-gray-500 hover:bg-gray-600 text-white font-semibold text-sm sm:text-base rounded-lg transition duration-300"
              >
                Cancel
              </button>
            </div>
            {successMessage && (
              <p className="text-green-600 text-sm sm:text-base mt-2 text-center">{successMessage}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};
